<template lang="html">
  <div class="collect-custom-info">
    <div
      class="section"
      v-for="(section, index) in customInfo"
      :key="'section_' + index"
    >
      <!-- <div class="section-title pf-medium">{{ section.title }}</div> -->
      <div class="section-field-wrapper pf-simbold">
        <div class="field">
          <div>{{ section.orderExtendInfoName }}</div>
          <p
            v-if="section.AddInfoDetails && section.AddInfoDetails.length > 0"
            class="pf-simbold"
          >
            {{ section.AddInfoDetails.map(x => x.Content).join(';') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customInfo: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.collect-custom-info {
  margin: rem(20px) rem(24px) rem(20px);
  border-radius: rem(16px);
  overflow: hidden;

  .section {
    padding: rem(15px) rem(24px) rem(15px) rem(24px);
    background: #fff;
    font-size: rem(24px);
    color: #262626;
    line-height: rem(30px);

    .section-title {
      font-size: rem(30px);
      padding: 0 0 rem(30px) 0;
    }

    .section-field-wrapper {
      display: flex;
      flex-direction: column;

      font-size: rem(26px);
      color: #121212;
      font-weight: 500;

      .field {
        display: flex;
        padding: rem(22px) 0 rem(22px) 0;
        div {
          width: rem(200px);
        }
        > p {
          flex: 1;
          text-align: right;
        }
      }
    }
  }
}
</style>
